import React, { useState } from 'react';
import '../css/EnquiryForm.css';

const EnquiryForm = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    enquiryType: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = (e) => {
    e.preventDefault();

    // Construct WhatsApp message
    const message = `New Enquiry from Website:
Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Enquiry Type: ${formData.enquiryType}
Message: ${formData.message}`;

    // Encode message for URL
    const encodedMessage = encodeURIComponent(message);

    // WhatsApp URL
    const whatsappURL = `https://api.whatsapp.com/send?phone=+919175577266&text=${encodedMessage}`;

    // Open WhatsApp in new tab
    window.open(whatsappURL, '_blank');

    // Optionally reset form and show success message
    setIsSubmitted(true);
    setFormData({ name: '', email: '', phone: '', enquiryType: '', message: '' });
  };

  return (
    <div>


<section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>Enquiry</h1>
    </div>
  </div>
</section>

 

      <section className="enquiry-form pt-6 pb-6">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 mx-auto">
              <div className="enquiry-form-box bg-white p-5 rounded shadow">
                <h2 className="text-center mb-4">Enquire About Woodland Escape </h2>
                <p className="text-center mb-4">
                  Fill out the form below to get more information or make a booking enquiry.
                </p>

                {isSubmitted && (
                  <div className="alert alert-success text-center mb-4">
                    Your enquiry has been prepared for WhatsApp. Click 'Open WhatsApp' to send!
                  </div>
                )}

                <form onSubmit={onSubmit}>
                  <div className="form-group mb-3">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group mb-3">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group mb-3">
                    <input
                      type="tel"
                      name="phone"
                      className="form-control"
                      placeholder="Your Phone Number"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group mb-3">
                    <select
                      name="enquiryType"
                      className="form-control"
                      value={formData.enquiryType}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Enquiry Type</option>
                      <option value="Booking Inquiry">Booking Inquiry</option>
                      <option value="Tour Services">Tour Services</option>
                      <option value="Events and Special Offers">Events and Special Offers</option>
                      <option value="Family Picnic">Family Picnic</option>
                      <option value="Get Together">Get Together</option>
                      <option value="Corporate Picnic">Corporate Picnic</option>
                      <option value="School Picnic">School Picnic</option>
                      <option value="Other Enquiry">Other Enquiry</option>
                    </select>
                  </div>

                  <div className="form-group mb-3">
                    <textarea
                      name="message"
                      className="form-control"
                      rows="5"
                      placeholder="Enter your message or enquiry here..."
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className="text-center">
                    <button type="submit" className="btn btn-primary submit-btn">
                      Send Enquiry on WhatsApp 
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EnquiryForm;
